// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"86a02947","732":"4a5b3706","977":"61a37947"}[chunkId] + ".chunk.js";
};